export default {

    teachers: [
        { name: '松本和幸', position: '准教授', link: './members/kazuyuki_matsumoto' },
        { name: '吉田稔', position: '講師', link: './members/minoru_yoshida' },
        { name: '康鑫', position: '講師', link: './members/kang_xin' },
    ],
    // coteachers: [
    //     { name: '西村良太', position: '講師', link: './members/ryota_nishimura' },
    // ],
    doctors: [
        { name: '王麟皇', year: '博士3年', link: './members/wang' },
        { name: '周嘉政', year: '博士1年', link: './members/zhou' },
    ],
}